import ChatInputAdorements from "src/reusable/Chat/PromptInput/ChatInputAdorements";
import ChatPersonaSelectButton from "src/reusable/Chat/PromptInput/ChatPersonaSelectButton";
import { useIsAdmin } from "src/helpers/useIsAdmin";
import { Stack } from "@mui/material";
import {
  TokenUsageGauge,
  type TokenUsageData,
} from "src/reusable/Chat/TokenUsageGauge";

type WorkflowChatInputButtonsProps = {
  isInputting: boolean;
  isChatLoading: boolean;
  isGenerating: boolean;
  handleFormSubmit: (event: React.FormEvent | React.KeyboardEvent) => void;
  onStopChat: () => void;
  tokenUsage?: TokenUsageData | null;
};

/**
 * The standard workflow-product input-button row: the persona/agent selector
 * on the left (same composition as Atom Assist's AAChatInputButtons), token
 * gauge and send/stop on the right.
 */
const WorkflowChatInputButtons = ({
  isInputting,
  isChatLoading,
  isGenerating,
  handleFormSubmit,
  onStopChat,
  tokenUsage,
}: WorkflowChatInputButtonsProps) => {
  // Engineers never pick the agent on workflow surfaces — the slot binding
  // resolves it. Admins keep the picker for configuration and QA.
  const isAdmin = useIsAdmin();
  return (
    <Stack
      direction="row"
      justifyContent={isAdmin ? "space-between" : "flex-end"}
      alignItems="flex-end"
      sx={{ width: "100%" }}
      gap={2}
    >
      {isAdmin && <ChatPersonaSelectButton />}
      <Stack direction="row" justifySelf="flex-end" alignItems="center" gap={2}>
        {tokenUsage && (
          <TokenUsageGauge tokenUsage={tokenUsage} variant="circular" />
        )}
        <ChatInputAdorements
          isInputting={isInputting}
          isChatLoading={isChatLoading}
          isGenerating={isGenerating}
          handleFormSubmit={handleFormSubmit}
          onStopChat={onStopChat}
        />
      </Stack>
    </Stack>
  );
};

export default WorkflowChatInputButtons;
